import * as React from 'react'

import type moment from 'moment'

import { observer } from 'mobx-react'

import TooltipWrapper from 'modules/shift_management/components/ShiftManagement/TooltipWrapper'
import { useSchedule } from 'modules/shift_management/hooks/useSchedule'
import type { Shift } from 'modules/shift_management/lib/types'
import type PlannedBreak from 'modules/time_planning/store/internal/models/PlannedBreak'

import Basic from './Basic'
import Full from './Full'

export interface Props {
  shift: Shift
  date: moment.Moment
  plannedBreaks: PlannedBreak[]
}

const ShiftTime = ({ shift, date, plannedBreaks }: Props) => {
  const [{ view }] = useSchedule()

  return (
    <TooltipWrapper.Alt label={shift.formattedDuration(plannedBreaks)}>
      {view.isFullVersion ? (
        <Full shift={shift} date={date} />
      ) : (
        <Basic shift={shift} date={date} />
      )}
    </TooltipWrapper.Alt>
  )
}

export default observer(ShiftTime)
